/** Case-insensitive "Yes" / "No" pair as used in RogerDoc radio `values`. */
export function resolveYesNoOptionPair(
  values: string[] | undefined
): { yesValue: string; noValue: string } | null {
  if (!values || values.length !== 2) return null;
  const a = values[0].trim();
  const b = values[1].trim();
  if (!a || !b || a === b) return null;
  const ai = a.toLowerCase();
  const bi = b.toLowerCase();
  if (ai === 'yes' && bi === 'no') {
    return { yesValue: a, noValue: b };
  }
  if (ai === 'no' && bi === 'yes') {
    return { yesValue: b, noValue: a };
  }
  return null;
}
